import React from 'react';
import './ProgrammeBody.css';
import ProgrammeBodyElement from './ProgrammeBodyElement';

// render the programme body
const ProgrammeBody = (props) => {
  const isFirstLoad = props.isFirstLoad;
  const theProgramme = props.theProgramme;

  // determine statuses and other info
  const unavailableTerm = "Unavailable";
  const unavailableTermClassCode = "No class code available";
  const isProgrammeDefined = theProgramme !== undefined;
  const name = isProgrammeDefined ? !!theProgramme.name ? theProgramme.name : unavailableTerm : undefined;
  const subjectName = isProgrammeDefined ? !!theProgramme.subjectName ? theProgramme.subjectName : unavailableTerm : undefined;
  const isOpenForApplication = isProgrammeDefined ? theProgramme.isOpenForApplication : false;
  const classViewerUrl = process.env.REACT_APP_APP_CLASSVIEWER_BASE || 'BUGGER:REACT_APP_APP_CLASSVIEWER_BASE';
  const classViewerLink = classViewerUrl + '?uniqueRef=';

  const classesElements = isProgrammeDefined
    ? [...theProgramme.classes]
      .sort((a, b) => {
        // Get the class Year
        const yearA = a.uniqueRef.slice(2, 4);
        const yearB = b.uniqueRef.slice(2, 4);

        // Sort by classYear descending
        if (yearA !== yearB) {
          return yearB.localeCompare(yearA);
        }

        // Sort by the full uniqueRef asecnding
        return a.uniqueRef.localeCompare(b.uniqueRef);
      })
      .map((classItem, index) => {

        let classStatus = "";
        let statusIcon = "";

        if (classItem.isCancelled) {
          classStatus = "Cancelled";
          statusIcon = "/programme-viewer-images/cancelled.svg";
        } else if (classItem.isEnrolling) {
          classStatus = "Enrolling";
          statusIcon = "/programme-viewer-images/enrolling.svg";
        } else if (classItem.isWaitlisting) {
          classStatus = "Waitlisting";
          statusIcon = "/programme-viewer-images/waitlisting.svg";
        } else {
          classStatus = "Not open for applications"
          statusIcon = "/programme-viewer-images/not-open-for-application.svg";
        }

        return (
          <ProgrammeBodyElement
            key={classItem.uniqueRef} // TODO TG: shouldn't that be the id?
            title={!index ? "Classes" : ""}
            text={<a href={classViewerLink + classItem.uniqueRef}>{classItem.uniqueRef}</a>}
            subText={classItem.classCode === unavailableTerm ? unavailableTermClassCode : classItem.classCode}
            subIconText={classStatus}
            subIcon={statusIcon}
          />
        )
      }) : <></>;

  // render either that we're loading data (if loaded for the first time), or the programme, or that the programme does not exist
  return isProgrammeDefined
    ? <>
      <ProgrammeBodyElement title="Name" text={name} />
      <ProgrammeBodyElement title="Subject" text={subjectName} />
      <ProgrammeBodyElement
        title="Status"
        icon={isOpenForApplication ? "/programme-viewer-images/open-for-application.svg" : "/programme-viewer-images/not-open-for-application.svg"}
        iconAlt="open for application icon"
        text={isOpenForApplication ? "Open for applications" : "Not open for applications"}
        textColor={isOpenForApplication ? "openForApplication" : undefined}
        visible={isProgrammeDefined}
      />
      {classesElements}
    </>
    : isFirstLoad
      ? // this is the very first load
      <ProgrammeBodyElement title="Loading ..." className="notification" />
      : // this is a subsequent load
      <ProgrammeBodyElement title="Programme does not exist." className="error" />
}

export default ProgrammeBody;
